import React, { useEffect, useMemo, useState } from 'react';
import {
  StyledBingoPopMainProduct,
  StyledBingoPopProducts,
  StyledBingoPopSubProduct,
  StyledSubContainer,
} from './styles';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { ProductData } from 'utils/types';
import { Divider } from '@mui/material';

export type IBingoPopProductsProps = {
  productList: ProductData[];
};

export const BingoPopProducts: React.FC<IBingoPopProductsProps> = ({
  productList,
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData>();
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    setMainProduct(productList[0]);

    setSubProducts(productList.slice(1));
  }, [productList]);

  const hasSubProducts = useMemo(
    () => subProducts && subProducts?.length > 0,
    [subProducts?.length],
  );
  return (
    <StyledBingoPopProducts>
      <div className={'products-section'}>
        <div className="main-section">
          {mainProduct && (
            <StyledBingoPopMainProduct textColor={mainProduct.textFontColorHex}>
              <div className="image-container">
                <img
                  src={mainProduct.images.product}
                  alt="product"
                  className="image"
                />
              </div>
              <span className="quantity">
                <AutoTextSize
                  maxFontSizePx={32}
                  minFontSizePx={6}
                  mode="oneline"
                >
                  {mainProduct.quantityDisplay}
                </AutoTextSize>
              </span>
            </StyledBingoPopMainProduct>
          )}
        </div>
        {hasSubProducts && (
          <Divider orientation="vertical" className={'types-divider'} />
        )}
        <StyledSubContainer>
          {subProducts.map((sub) => (
            <StyledBingoPopSubProduct textColor={sub.textFontColorHex}>
              <div className="image-container">
                <img src={sub.images.product} alt="product" className="image" />
              </div>
              <span className="quantity">
                <AutoTextSize
                  maxFontSizePx={18}
                  minFontSizePx={6}
                  mode="oneline"
                >
                  {sub.quantityDisplay}
                </AutoTextSize>
              </span>
            </StyledBingoPopSubProduct>
          ))}
        </StyledSubContainer>
      </div>
    </StyledBingoPopProducts>
  );
};
